import { render, staticRenderFns } from "./GestionTypeReglement.vue?vue&type=template&id=71d05809&scoped=true&"
import script from "./GestionTypeReglement.vue?vue&type=script&lang=js&"
export * from "./GestionTypeReglement.vue?vue&type=script&lang=js&"
import style0 from "./GestionTypeReglement.vue?vue&type=style&index=0&id=71d05809&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d05809",
  null
  
)

export default component.exports